import Backdrop from '../Backdrop/view';
import Button from '../../atoms/Button/view';
import { Icon } from '../../atoms/Icon/view';
import { Text } from '../../atoms/Text/view';

interface PropsAiInfoSheet {
  open: boolean;
  onClose: () => void;
}

export default function AiInfoSheet({ open, onClose }: PropsAiInfoSheet) {
  return (
    <Backdrop open={open} onClose={onClose} position="bottom">
      <div className="p-medium">
        <div className="flex items-center gap-smaller">
          <div className="h-[44px] w-[44px] rounded-full bg-support-01 flex items-center justify-center">
            <Icon name="icon-ai" size={22} color="#1D4733" rounded={false} />
          </div>
          <div>
            <Text className="text-paragraphLG color-complement-01">Extração de PDF</Text>
            <Text className="text-bodySM color-intense-06">
              Seu contrato cadastrado em segundos
            </Text>
          </div>
        </div>
        <Text className="mt-medium text-bodyMD color-intense-07">
          Envie o PDF do seu contrato e nós extraímos as principais informações:
          instituição, valor financiado, taxa, indexador, prazo e o cronograma de
          parcelas. Você confere e ajusta na próxima tela antes de salvar.
        </Text>
        <Button text="Entendi" onClick={onClose} fullWidth className="mt-medium" />
      </div>
    </Backdrop>
  );
}
